module.exports = __webpack_public_path__ + "img/高速4.cbcf0b31.png";